import * as tslib_1 from "tslib";
/*
 * @Descripttion:
 * @version: v1.0
 * @Author: baidongsheng
 * @Date: 2021-09-06 17:37:05
 * @LastEditors: Fu Zhuohang
 * @LastEditTime: 2022-03-07 14:27:04
 */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist';
import System from './modules/system/index';
import WorkflowCenter from './modules/workflow-center/index';
import { bizpropertyApi } from "@cloudpivot/api";
const vuexLocal = new VuexPersistence({
    key: 'vuex',
    storage: localStorage,
    reducer: (state) => ({
        appCode: state.appCode
    })
});
Vue.use(Vuex);
export default new Vuex.Store({
    namespace: true,
    state: {
        appCode: '',
        config: {},
        formRuleList: [],
        motalflag: null,
        outwardType: 'light',
        themeColor: 'blue',
        themsConfig: {
            backLogo: '',
            color: '',
            icon: '',
            info: '',
            name: '',
            outward: '',
            portalLogo: '',
        },
        loaded: false,
    },
    mutations: {
        setAppCode(state, appCode) {
            state.appCode = appCode;
        },
        setConfig(state, config) {
            state.config = config;
            localStorage.setItem("stateConfig", JSON.stringify(config));
        },
        setFormRuleList(state, val) {
            state.formRuleList = val;
        },
        setMotalflag(state, flag) {
            state.motalflag = flag;
        },
        setOutwardType(state, type) {
            state.outwardType = type;
        },
        setThemeColor(state, colorName) {
            state.themeColor = colorName;
        },
        setThemsConfig(state, config) {
            state.themsConfig = config;
            state.loaded = true;
        },
    },
    actions: {
        getFormRuleList({ commit, state }, param) {
            return tslib_1.__awaiter(this, void 0, void 0, function* () {
                const params = {
                    schemaCode: param.bizSchemaCode
                };
                const res = yield bizpropertyApi.getDataRules(params);
                if (res.errcode === 0) {
                    commit('setFormRuleList', res.data);
                }
            });
        },
    },
    modules: {
        WorkflowCenter,
        System
    },
    plugins: [vuexLocal.plugin]
});
